<template lang="html">
    <div
        class="group-checkbox"
        :class="groupState"
    >
        <or-icon icon="done" />
        <span class="minus">-</span>
        <input
            type="checkbox"
            :checked="groupIsChecked"
            :disabled="disabled"
            @change.stop="$emit('toggle-checkbox-group')"
            @click.stop
        >
    </div>
</template>
<script>
export default {
  props: {
    groupState: String, // 'checked' | some-checked' | 'not-checked'
    disabled: Boolean
  },

  computed: {
    groupIsChecked () {
      return this.$props.groupState === 'checked'
    }
  }
}
</script>
<style lang="scss" scoped>
    .group-checkbox {
        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;
        width: 16px;
        height: 16px;
        border: 1px solid $or-grey-medium;
        background-color: white;
        border-radius: 2px;
        margin-right: 4px;

        &.checked {
            background-color: $or-blue;
            border: none;

            &:hover {
                background-color: darken($or-blue, 5%);
                transition: all .2s ease;
            }

            .material-icons {
                display: block;
            }
        }

        &.some-checked {
            background-color: $or-blue;
            border: none;
            color: white;

            &:hover {
                background-color: darken($or-blue, 5%);
                transition: all .2s ease;
            }

            .minus {
                display: block;
                margin-bottom: 2px;
            }
        }

        input {
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            opacity: 0;

            &:hover:not([disabled]) {
                cursor: pointer;
            }
        }

        .material-icons {
            display: none;
            color: #fff;
            font-size: 12px;
        }

        .minus {
            color: white;
            display: none;
        }
    }
</style>
